import {combine, restore} from 'effector';
import {createGate} from 'effector-react';

import {changeInvoiceStatus, fetchBillingInvoices} from 'api/billing';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {
    BillingBalance,
    BillingInvoicePageableContent,
    BillingInvoiceRawRow,
    BillingPageableContent,
    BillingRawRow,
    ChangeInvoiceStatusRequest,
} from 'types/billing';

const domain = rootDomain.createDomain('billingInvoicesTableDomain');

export const loadBillingInvoicesDataFx = domain.createEffect({
    name: 'loadBillingInvoicesDataFx',
    handler: fetchBillingInvoices,
});

export const changeInvoiceStatusFx = domain.createEffect({
    name: 'changeInvoiceStatusFx',
    handler: changeInvoiceStatus,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    Gate: BillingInvoicesGate,
    tableStateChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const searchByIdChanged = domain.createEvent<string>();
export const searchByTinChanged = domain.createEvent<string>();
export const searchByIrnChanged = domain.createEvent<string>();

export const searchById$ = domain
    .createStore<string | null>(null)
    .on(searchByIdChanged, (_, value) => value)
    .reset(BillingInvoicesGate.close);
export const searchByTin$ = domain
    .createStore<string | null>(null)
    .on(searchByTinChanged, (_, value) => value)
    .reset(BillingInvoicesGate.close);
export const searchByIrn$ = domain
    .createStore<string | null>(null)
    .on(searchByIrnChanged, (_, value) => value)
    .reset(BillingInvoicesGate.close);

export const billingList$ = domain.createStore<BillingInvoicePageableContent | null>(null);

export const billingState$ = combine({
    data: billingList$,
    loading: loadBillingInvoicesDataFx.pending,
});

export const tableState$ = combine({
    data: billingList$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    searchById: searchById$,
    searchByTin: searchByTin$,
    searchByIrn: searchByIrn$,
});

export const setInvoiceStatusChangeModalHandler = domain.createEvent<{
    show: boolean;
    data: ChangeInvoiceStatusRequest | null;
}>();
export const $invoiceStatusChangeModalHandler = restore(setInvoiceStatusChangeModalHandler, {
    show: false,
    data: null,
}).reset(BillingInvoicesGate.close);
